import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { keys } from "./keys";

// Active sub-topic count per topic, fetched in a SINGLE request for all the
// given topic ids (avoids one query per topic row). Only the `topic_id`
// column is transferred; counts are aggregated client-side.
async function fetchActiveCounts(topicIds: string[]): Promise<Record<string, number>> {
  const { data, error } = await apiClient
    .from('sub_topics')
    .select('topic_id')
    .in('topic_id', topicIds)
    .is('archived_at', null);

  if (error) {
    throw error;
  }

  const counts: Record<string, number> = {};
  for (const row of data ?? []) {
    counts[row.topic_id] = (counts[row.topic_id] ?? 0) + 1;
  }
  return counts;
}

export function useGetSubTopicActiveCounts(topicIds: string[]) {
  return useQuery({
    queryKey: keys.subTopicActiveCounts(topicIds),
    queryFn: () => fetchActiveCounts(topicIds),
    enabled: topicIds.length > 0,
  });
}
